import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {
  getCepData,
  getCepColumns,
  getCepIsLoading,
} from '../redux/selectors/ImpcStockLevelsAllSelectors';
import ListTable from '../../../common/tables/ListTable';
import TableDefinitions from '../../../common/TableDefinitions';
import { ImpcStockLevelsStyle } from './ImpcStockLevels.styles';

function ImpcStockLevelsCentralEntryPointTableContainer(props) {
  return (
    <ImpcStockLevelsStyle selectedRowIndex={props.selectedRowIndex}>
      <ListTable
        listId={TableDefinitions.IMPC_STOCK_LEVELS_ALL_LIST.id}
        loading={props.isLoading}
        columns={props.columns}
        data={props.data}
        getTrProps={props.selectedRow}
      />
    </ImpcStockLevelsStyle>
  );
}

function mapStateToProps(state) {
  return {
    data: getCepData(state),
    columns: getCepColumns(state),
    isLoading: getCepIsLoading(state),
  };
}

ImpcStockLevelsCentralEntryPointTableContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  selectedRow: PropTypes.func,
  isLoading: PropTypes.bool,
  selectedRowIndex: PropTypes.number,
};

export default connect(mapStateToProps)(ImpcStockLevelsCentralEntryPointTableContainer);
